export const enum ServiceEventTypes {
  CREATION = 'created',
  UPDATE = 'updated',
  REJECTION = 'correction_requested',
  DELIVERY = 'delivered'
}
